import { render, staticRenderFns } from "./double2.vue?vue&type=template&id=220d62b2&scoped=true"
import script from "./double2.vue?vue&type=script&lang=ts"
export * from "./double2.vue?vue&type=script&lang=ts"
import style0 from "./double2.vue?vue&type=style&index=0&id=220d62b2&prod&scoped=true&lang=css"
import style1 from "./double2.vue?vue&type=style&index=1&id=220d62b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d62b2",
  null
  
)

export default component.exports